import { render } from "./ImageBlob.vue?vue&type=template&id=88060838&scoped=true"
import script from "./ImageBlob.vue?vue&type=script&lang=js"
export * from "./ImageBlob.vue?vue&type=script&lang=js"

import "./ImageBlob.vue?vue&type=style&index=0&id=88060838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88060838"]])

export default __exports__